import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchGigs = async () => (await apiClient.get("/gigs")).data;
export const fetchMixes = async () => (await apiClient.get("/mixes")).data;
export const submitBooking = async (payload) =>
  (await apiClient.post("/bookings", payload)).data;
